/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class DataEntryTemplateExportControllerService extends DataBaseService {

  /**
   * Path part for operation dataEntryTemplateExportControllerExportEntriesWithTemplateV2
   */
  static readonly DataEntryTemplateExportControllerExportEntriesWithTemplateV2Path = '/v1/entities/{entity}/entries/export/{templateId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEntriesWithTemplateV2$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$Json$Response(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntryTemplateExportControllerService.DataEntryTemplateExportControllerExportEntriesWithTemplateV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('templateId', params.templateId, {});
      rb.query('mode', params.mode, {});
      rb.query('itemsToExport', params.itemsToExport, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('sourceCollection', params.sourceCollection, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportEntriesWithTemplateV2$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$Json(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<{
'success'?: boolean;
}> {

    return this.exportEntriesWithTemplateV2$Json$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntryTemplateExportControllerService.DataEntryTemplateExportControllerExportEntriesWithTemplateV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('templateId', params.templateId, {});
      rb.query('mode', params.mode, {});
      rb.query('itemsToExport', params.itemsToExport, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('sourceCollection', params.sourceCollection, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentWordprocessingmlDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentWordprocessingmlDocument$Response(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntryTemplateExportControllerService.DataEntryTemplateExportControllerExportEntriesWithTemplateV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('templateId', params.templateId, {});
      rb.query('mode', params.mode, {});
      rb.query('itemsToExport', params.itemsToExport, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('sourceCollection', params.sourceCollection, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentWordprocessingmlDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentWordprocessingmlDocument(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.exportEntriesWithTemplateV2$VndOpenxmlformatsOfficedocumentWordprocessingmlDocument$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEntriesWithTemplateV2$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$Pdf$Response(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntryTemplateExportControllerService.DataEntryTemplateExportControllerExportEntriesWithTemplateV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('templateId', params.templateId, {});
      rb.query('mode', params.mode, {});
      rb.query('itemsToExport', params.itemsToExport, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('sourceCollection', params.sourceCollection, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportEntriesWithTemplateV2$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntriesWithTemplateV2$Pdf(params: {
    entity: string;
    templateId: string;
    mode?: number;
    itemsToExport?: Array<string>;
    filterCriteria?: any;
    search?: string;
    sourceCollection?: string;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.exportEntriesWithTemplateV2$Pdf$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
